<script>
	export let layout;
	export let hover = null;
	export let interactive = false;
	export let onEnter = null;
	export let onLeave = null;

	const isActive = (s, h) => h && h.kind === "mark" && h.index === s.i;
</script>

{#each layout.slices as s}
	<!-- svelte-ignore a11y_no_static_element_interactions (The parent SVG handles keyboard selection of every slice.) -->
	<path
		d={s.d}
		class="slice"
		class:lift={isActive(s, hover)}
		class:dim={hover && hover.kind === "mark" && hover.index !== s.i}
		style="--c:{s.color}"
		on:pointerenter={(e) => interactive && onEnter && onEnter(s.i, e)}
		on:pointerdown={(e) => interactive && onEnter && onEnter(s.i, e)}
		on:pointerleave={(e) => interactive && onLeave && onLeave(e)}
	/>
{/each}
{#each layout.slices as s}
	{#if s.showLabel}
		<text class="pct" x={s.lx} y={s.ly} text-anchor="middle" dominant-baseline="middle">{s.pct}</text>
	{/if}
{/each}
{#if layout.r0 && layout.total}
	<text class="total" style="font-size:{layout.totalFontSize}px" x={layout.cx} y={layout.cy - 4} text-anchor="middle" dominant-baseline="auto">{layout.totalText}<title>{layout.fullTotal}</title></text>
	<text class="totalLabel" x={layout.cx} y={layout.cy + 12} text-anchor="middle" dominant-baseline="hanging">Total</text>
{/if}

<style>
	.slice {
		fill: var(--c);
		/* the 2px surface gap between slices */
		stroke: var(--_surface);
		stroke-width: 2;
		stroke-linejoin: round;
	}

	.slice.lift {
		stroke-width: 3;
	}

	.slice.dim {
		opacity: 0.6;
	}

	@media (prefers-reduced-motion: no-preference) {
		.slice {
			transition: opacity 0.12s ease-out;
		}
	}

	.pct {
		fill: var(--_pie-label);
		font-size: 12px;
		font-weight: 600;
		font-variant-numeric: tabular-nums;
		paint-order: stroke;
		stroke: none;
		stroke-width: 2.5px;
		stroke-linejoin: round;
		pointer-events: none;
	}

	.total {
		fill: var(--_ink);
		font-size: 18px;
		font-weight: 600;
		font-family: var(--_num-font);
		pointer-events: none;
	}

	.totalLabel {
		fill: var(--_ink-muted);
		font-size: 11px;
		text-transform: uppercase;
		letter-spacing: 0.06em;
		pointer-events: none;
	}
</style>
